import React from 'react';
import PropTypes from 'prop-types';

import { Icon, Translate, SafeAnchor } from '@hydra/common/components';
import { Criterium, CriteriumTable } from '@hydra/common/criterium';

import { useI18n } from '@hydra/common/customHooks';

export const columns = [
  <SafeAnchor href='https://en.wikipedia.org/wiki/Country_code_top-level_domain' rel='nofollow noopener noreferrer' target='_blank' key='Country_code_top-level_domain'>
    <Translate content='generic_domain' />
  </SafeAnchor>,
  <Translate content='status' key='status' />,
  ''
];

export const createTableRow = ({ domain, isAvailable, expiresAt, moment }) => {
  const domainText = <span>{domain}</span>;
  const statusText = isAvailable
    ? (
      <span>
        <Translate content='domain_available' />
        {' '}
        <SafeAnchor href='http://bit.ly/1qKTAle' title='http://bit.ly/1qKTAle' rel='nofollow noopener noreferrer' target='_blank'>
          <Translate content='eurdns_book_it' />
        </SafeAnchor>
      </span>
      )
    : expiresAt
      ? <Translate content='domain_expire' with={{ expiresIn: moment(expiresAt).fromNow() }} />
      : <Translate content='domain_booked' />;

  const icon = isAvailable
    ? <Icon type='woorank-success' color='success' size='xs' />
    : <Icon type='lock' color='grey' size='xs' />;

  return [
    domainText,
    statusText,
    icon
  ];
};

export const TldCybersquatingPrevention = ({ criterium }) => {
  const { moment } = useI18n();
  const { data } = criterium;

  const i18nData = data.map(data => {
    return { ...data, moment };
  });

  const body = i18nData.map(createTableRow);
  const tableClasses = {
    body: ['', '', 'alignRight']
  };

  const content = (
    <CriteriumTable
      classNames={tableClasses}
      fixedColumns={[3, 5, 2]}
      head={columns}
      rows={body}
      thinHead
      striped
      nowrap
    />
  );

  return <Criterium criterium={criterium}>{content}</Criterium>;
};

TldCybersquatingPrevention.propTypes = {
  criterium: PropTypes.shape({
    data: PropTypes.arrayOf(
      PropTypes.shape({
        domain: PropTypes.string,
        isAvailable: PropTypes.bool,
        expiresAt: PropTypes.number
      })
    )
  })
};

export default React.memo(TldCybersquatingPrevention);
